import { headerStatus } from 'interfaces/header-status.enum';

interface TestnetNavlink {
  title: string;
  href: string;
  subTitle: string;
  target?: string;
  order?: string;
}

export const TESTNET_NAV_LINKS: TestnetNavlink[] = [
  {
    title: 'Testnet',
    href: '/testnet',
    subTitle:
      'Deploy your contracts and experience the incredible speed of SFI.',
    order: 'order-1 lg:order-1',
  },
  {
    title: 'Ecosystem',
    href: '/testnet/ecosystem',
    subTitle:
      'Discover the various projects in the Singularity Finance ecosystem',
    order: 'order-2 lg:order-3',
  },
  {
    title: 'Dashboard',
    href: '/testnet/dashboard',
    subTitle: 'View your points',
    order: 'order-3 lg:order-5',
  },
  {
    title: 'Leaderboard',
    href: 'https://zealy.io/cw/singularityfinance',
    target: '_blank',
    subTitle: 'Bridge, use Dapps, & invite friends to rank up.',
    order: 'order-4 lg:order-7',
  },
  {
    title: 'Claim Rewards',
    href: '/testnet/claim',
    subTitle: 'Claim your testnet rewards',
    order: 'order-5 lg:order-2',
  },
  {
    title: 'DEX',
    target: '_blank',
    href: `https://dex.${process.env.NEXT_PUBLIC_SFI_URL}`,
    subTitle: '',
    status: headerStatus.ENDED,
    order: 'order-6 lg:order-2',
  },
  {
    title: 'Bridge',
    target: '_blank',
    href: `https://bridge-testnet.singularityfinance.ai/bridge/singularity-finance-testnet`,
    subTitle: '',
    status: headerStatus.ENDED,
    order: 'order-7 lg:order-4',
  },
  {
    title: 'Faucet',
    href: `https://faucet-testnet.singularityfinance.ai/`,
    target: '_blank',
    subTitle: '',
    status: headerStatus.ENDED,
    order: 'order-8 lg:order-6',
  },
  {
    title: 'Staking',
    href: '/testnet/staking',
    subTitle: '',
    status: headerStatus.ENDED,
    order: 'order-9 lg:order-8',
  },
  {
    title: 'Swap',
    href: '/testnet/swap',
    subTitle: '',
    status: headerStatus.ENDED,
    order: 'order-10 lg:order-10',
  },
];

interface TestnetNavlink {
  title: string;
  href: string;
  subTitle: string;
  target?: string;
  status?: string;
}

interface TestnetLink {
  link: string;
  target?: string;
  href: string;
  disabled?: boolean;
}

export const TESTNET_LINKS: TestnetLink[] = [
  {
    link: 'Blockexplorer',
    target: '_blank',
    href: 'https://explorer-testnet.singularityfinance.ai/',
    disabled: true,
  },
  {
    link: 'Docs',
    target: '_blank',
    href: 'https://docs.singularityfinance.ai/',
  },
];

interface MenuItem {
  title: string;
  href: string;
  visible: boolean;
  target?: string;
  status?: string;
  isExternal?: boolean;
}

export const MENU: MenuItem[] = [
  {
    title: 'Migrate NOW',
    href: '/migrate',
    visible: true,
  },
  {
    title: 'AI assistant',
    href: '/chat',
    visible: true,
    status: headerStatus.BETA,
  },
];

export const MOBILEMENU: MenuItem[] = [
  {
    title: 'Capital Manager',
    href: '/capital_manager',
    visible: true,
    status: headerStatus.BETA,
  },
  {
    title: 'AI assistant',
    href: '/chat',
    visible: true,
    status: headerStatus.BETA,
  },
  // {
  //   title: 'Dashboard',
  //   href: '/portfolio',
  //   visible: true,
  // },
  {
    title: 'Vault',
    href: '/vaults',
    visible: true,
    status: headerStatus.LIVE,
  },
  {
    title: 'Staking',
    href: '/staking',
    visible: true,
    status: headerStatus.LIVE,
  },
  {
    title: 'Bridge',
    href: '/bridge',
    visible: true,
  },
  {
    title: 'Migrate',
    href: '/migrate',
    visible: true,
  },
  {
    title: 'Docs',
    target: '_blank',
    href: 'https://docs.singularityfinance.ai/',
    visible: true,
    isExternal: true,
  },
];
